import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import { CustomIconButton } from '../../../layout/styledcomponents/CustomIconButton';

const TeamsToolbar = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const handleAddClick = () => {
        navigate(`/newTeam`);
    };

    return (
        <Grid
            sx={{
                textAlign: ' right',
                paddingBottom: '20px',
            }}
        >
            {isMobile || isIpad ? (
                <CustomIconButton
                    variant='contained'
                    color='primary'
                    onClick={handleAddClick}
                >
                    <AddCircleIcon />
                </CustomIconButton>
            ) : (
                <CustomButton
                    id='addTeam'
                    variant='contained'
                    color='primary'
                    startIcon={<AddCircleIcon />}
                    onClick={handleAddClick}
                >
                    Add{' '}
                </CustomButton>
            )}
        </Grid>
    );
};

export default TeamsToolbar;
